import { redactTelemetryString } from "./privacy";

const PARAMETERIZED_ROUTES = new Map<string, string>([
  ["editor", "$strategyInstanceId"],
  ["onboarding", "$onboardingId"],
  ["portfolio", "$portfolioInstanceId"],
  ["start", "$stepId"],
  ["strategy", "$blueprintId"],
  ["symbol", "$symbol"],
  ["template", "$blueprintId"],
  ["user", "$userId"],
  ["welcome", "$stepId"],
]);

function normalizePathname(pathname: string): string {
  const pathOnly = pathname.split(/[?#]/u, 1)[0] ?? "/";
  return pathOnly.startsWith("/") ? pathOnly : `/${pathOnly}`;
}

export function toRouteTelemetryPath(pathname: string): string {
  const normalized = normalizePathname(pathname);
  const segments = normalized.split("/").filter(Boolean);
  const output: string[] = [];

  for (let index = 0; index < segments.length; index += 1) {
    const segment = segments[index];
    if (!segment) {
      continue;
    }

    output.push(redactTelemetryString(segment));

    if (segment === "asset" && segments[index + 1] && segments[index + 2]) {
      output.push("$chainId", "$tokenAddress");
      index += 2;
      continue;
    }

    if (segment === "crypto" && segments[index + 1] && segments[index + 2]) {
      output.push("$chain", "$tokenAddress");
      index += 2;
      continue;
    }

    if (segment === "agents" && segments[index + 1] === "tasks") {
      output.push("tasks");
      if (segments[index + 2]) {
        output.push("$taskId");
        index += 2;
      } else {
        index += 1;
      }
      continue;
    }

    if (segment === "agents" && segments[index + 1]) {
      output.push("$workflowId");
      index += 1;
      continue;
    }

    const parameterName = PARAMETERIZED_ROUTES.get(segment);
    if (parameterName && segments[index + 1]) {
      output.push(parameterName);
      index += 1;
    }
  }

  return output.length > 0 ? `/${output.join("/")}` : "/";
}
